import { Component, Input, OnInit } from '@angular/core';
import { IStockStatus } from './stock-status-model';

@Component({
  selector: 'app-stock-status-indicator',
  templateUrl: './stock-status-indicator.component.html',
  styleUrls: ['./stock-status-indicator.component.scss']
})
export class StockStatusIndicatorComponent implements OnInit {
  @Input() stockLevels!: IStockStatus[];
  @Input() branch!: string;
  branchStockInfo!: IStockStatus[];

  constructor() {}

  ngOnInit() {
    if (this.branch && this.stockLevels) {
      this.branchStockInfo = this.stockLevels.filter((x: any) => x.branch.code == this.branch);
    }
  }
}
